import React, { useState, useEffect, lazy, Suspense, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { ReactComponent as CheckBlueIcon } from "src/assets/static/images/check-blue-icon.svg";
import { ReactComponent as CheckGreenIcon } from "src/assets/static/images/green-check.svg";
import { ReactComponent as PlusCircleBlueIcon } from "src/assets/static/images/plus-circle-blue-icon.svg";
import { ReactComponent as XClose } from "src/assets/static/images/x-circle.svg";
import { ReactComponent as MarkX } from "src/assets/static/images/circle-xmark.svg";
import CustomDatePicker from "src/components/CursomDatePicker";
import authActions from "src/store/auth/actions";
import actions from "src/store/common/actions";
import mainActions from "src/store/profileMain/actions";
// import { PROFILE_ACCOUNT } from "../layout";
import { ReactComponent as CameraIcon } from "src/assets/static/images/cameraIco.svg";
import { ReactComponent as EyeOff } from "src/assets/static/images/eye-off.svg";
import { ReactComponent as EyeOn } from "src/assets/static/images/eye.svg";
import moment from "moment";
import useFormatById from "src/hooks/utils/useFormatById";
import formatTimer, { useTimer } from "src/components/login-form/useTimer";
import StrongPasswordValidation from "../ProfileMain/strongPasswordValidation";

export const CustomDatePickerLazy = lazy(() =>
  import("profileCommon_mf/CustomDatePicker")
);

import("profileCommon_mf/CustomDatePickerStyles");

const MyProfileContainer = () => {
  const f = useFormatById();

  const dispatch = useDispatch();
  const location = useLocation();
  const darkMode = useSelector((state) => state.common.darkMode);
  const [pId, setPId] = useState("");

  const profilePictureRef = useRef();

  const [childChoosed, setChildChoosed] = useState(false);
  const [smsCode, setSmscode] = useState("");
  const [addChildren, setAddChildren] = useState(false);
  const [isChangePassword, setIsChangePassword] = useState(false);
  const [temp, setTemp] = useState(false);
  const [addedSuccesfully, setAddedSuccesfully] = useState(false);

  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [repeateNewPassword, setRepeateNewPassword] = useState("");

  const [birthDate, setBirthDate] = useState("");
  const [formatedBirthDate, setFormatedBirthDate] = useState("");
  const [oldPasswordVisible, setOldPasswordVisible] = useState(false);
  const [newPasswordVisible, setNewPasswordVisible] = useState(false);
  const [repeatPasswordVisible, setRepeatPasswordVisible] = useState(false);
  const navigate = useNavigate();
  const mainPersonalInfo = useSelector(
    (state) => state.profileMain?.mainPersonalInfo
  );
  const openUserModal = useSelector(
    (state) => state.profileMain?.openUserModal
  );
  const policiesList = useSelector((state) => state.profileMain.policiesList);
  const mainAddedChildren = useSelector(
    (state) => state.profileMain?.mainAddedChildren
  );

  const mainFindChildren = useSelector(
    (state) => state.profileMain?.mainFindChildren
  );
  const insurerMobile = useSelector(
    (state) => state.profileMain?.insurerMobile
  );
  const mainCheckChild = useSelector(
    (state) => state.profileMain?.mainCheckChild
  );
  const OTPSended = useSelector((state) => state.profileMain?.OTPSended);

  const mainAddChild = useSelector((state) => state.profileMain?.mainAddChild);
  const [childAdd, setChildAdd] = useState(false);
  const [loading, setLoading] = useState(false);
  const changePassword = useSelector(
    (state) => state.profileMain?.changePassword
  );

  useEffect(() => {
    if (
      // !(mainAddedChildren?.length > 0) &&
      mainPersonalInfo?.parent === null &&
      mainPersonalInfo?.isUnderage !== true
    )
      dispatch(mainActions.getAddedChildren());
  }, [dispatch]);
  const [counterCheckChild, setCounterCheckChild] = useState(false);
  useEffect(() => {
    if (mainCheckChild === true && counterCheckChild === false) {
      setCounterCheckChild(true);
      dispatch(mainActions.getSendOTPInsurer({ personalNumber: pId }));
      setChildChoosed(true);
      setTemp(false);
    }
  }, [mainCheckChild, counterCheckChild]);
  useEffect(() => {
    if (mainCheckChild === false) {
      setCounterCheckChild(false);
    }
  }, [mainCheckChild]);
  useEffect(() => {
    setAddedSuccesfully(false);
  }, [insurerMobile]);

  useEffect(() => {
    if (mainPersonalInfo?.parent === null) {
      dispatch(mainActions.getInsurerMobile());
    }
  }, [dispatch]);

  const userChanged = useSelector((state) => state.profileMain?.userChanged);

  useEffect(() => {
    if (userChanged) {
      dispatch(mainActions.getPersonalInfo());
      dispatch(mainActions.setSwitchUser(false));
    }
  }, [userChanged, dispatch]);

  useEffect(() => {
    if (childAdd) {
      setPId(
        mainFindChildren?.find((x) => x.personalNumber === childAdd)
          ?.personalNumber
      );
      setBirthDate(
        mainFindChildren?.find((x) => x.personalNumber === childAdd)?.birthdate
      );
    }
  }, [childAdd]);

  const { pinTimer, setPinTimer } = useTimer();

  useEffect(() => {
    setFormatedBirthDate(moment(birthDate).format("yyyy-MM-DD"));
  }, [birthDate]);

  useEffect(() => {
    if (mainAddChild) {
      setAddedSuccesfully(true);
      setTemp(false);
      setChildChoosed(false);
      setLoading(false);
    }
  }, [mainAddChild]);

  useEffect(() => {
    if (
      mainPersonalInfo?.isUnderage === false &&
      mainPersonalInfo?.parent === null &&
      mainAddChild
    ) {
      dispatch(mainActions.getAddedChildren());
    }
  }, [mainAddChild, mainPersonalInfo]);

  useEffect(() => {
    if (OTPSended) {
      const minutes = 3;
      setPinTimer(minutes * 60);
      dispatch(mainActions.setSendOTPInsurer(false));
    }
  }, [OTPSended, dispatch, setPinTimer]);
  useEffect(() => {
    if (changePassword?.Success || changePassword === true) {
      setAddedSuccesfully(false);
      setIsChangePassword(false);
      setTemp(false);
      dispatch(mainActions.setAddchild(false));
      setIsChangePassword(false);
      setNewPassword("");
      setRepeateNewPassword("");
      setOldPassword("");
    }
  }, [changePassword]);
  useEffect(() => {
    return () => {
      setAddedSuccesfully(false);
      setIsChangePassword(false);
      setTemp(false);
      dispatch(mainActions.setAddchild(false));
      dispatch(mainActions.setCheckChild(false));
      dispatch(mainActions.setChangePassword(false));
      setNewPassword("");
      setRepeateNewPassword("");
      setOldPassword("");
    };
  }, []);
  const anyPasswordHasSpace =
    newPassword.includes(" ") ||
    oldPassword.includes(" ") ||
    repeateNewPassword.includes(" ");

  const errorMessages = {
    363: f("passwrod-validate"),
    364: f("login.PasswordIsIncorrect"),
    366: f("passwrod-dont-match"),
    374: f("passwrod-matches-old"),
  };
  const message = errorMessages[changePassword?.ExceptionCode];
  return (
    <div
      className={
        "my-profile-hover-block text-start p-3" + (darkMode ? " dark-mode" : "")
      }
    >
      {!addChildren && !isChangePassword && (
        <>
          <XClose
            onClick={() => {
              dispatch(mainActions.setOpenUserModal(false));
            }}
            style={{ float: "right", cursor: "pointer" }}
          />
          <div
            className={"insured-title mt-3" + (darkMode ? " dark-mode" : "")}
          >
            {f("myProfile.insured")}
          </div>
          {!mainPersonalInfo?.avatar && (
            <div className="avatars d-flex align-items-center">
              <CameraIcon
                className="me-2"
                style={{ width: "40px", height: "40px" }}
              />
              <div className={"insured-name mt-1" + ""}>
                {mainPersonalInfo?.firstName} {mainPersonalInfo?.lastName}{" "}
              </div>
              <div className="check-icon">
                <CheckBlueIcon className="float-end" />
              </div>
            </div>
          )}
          {mainPersonalInfo?.avatar && (
            <div className="avatars d-flex align-items-center">
              <img
                src={mainPersonalInfo?.avatar}
                className="profile-pic-style me-2"
                alt=""
                style={{ width: "40px", height: "40px" }}
                // onClick={() => profilePictureRef.current.click()}
              />
              <div className="insured-name mt-1">
                {mainPersonalInfo?.firstName} {mainPersonalInfo?.lastName}{" "}
              </div>
              <div className="check-icon">
                <CheckBlueIcon className="float-end" />
              </div>
            </div>
          )}
          {/* //*commented out children switching logic, leaving here if there's any need in the future */}
          {mainAddedChildren === null ? (
            <div
              className="spinner-border spinner-border-sm d-flex mx-auto mt-4"
              role="status"
              aria-hidden="true"
            ></div>
          ) : (
            mainAddedChildren && (
              <>
                <div
                  className={
                    "insured-title mt-3" + (darkMode ? " dark-mode" : "")
                  }
                >
                  {mainAddedChildren?.length > 0 &&
                  mainPersonalInfo?.parent === null
                    ? f("myProfile.children")
                    : mainPersonalInfo?.parent !== null
                    ? f("myProfile.parent")
                    : ""}
                </div>

                {mainPersonalInfo?.parent === null &&
                  mainAddedChildren?.map((item) => {
                    return (
                      <div
                        style={{ cursor: "pointer" }}
                        // onClick={() =>
                        //   mainPersonalInfo?.parent === null
                        //     ? dispatch(
                        //         mainActions.getSwitchUser({
                        //           UserId: item?.childUserId,
                        //         })
                        //       )
                        //     : dispatch(
                        //         mainActions.getSwitchUser({
                        //           UserId: mainPersonalInfo?.parent?.userId,
                        //         })
                        //       )
                        // }
                        onClick={() => {
                          const foundPolicy = policiesList?.find(
                            (x) => x?.pId === item?.personalNumber
                          );
                          const route = location.pathname;
                          dispatch(
                            mainActions.setScrollId(foundPolicy?.policeId)
                          );

                          dispatch(mainActions.setOpenUserModal(false));
                          if (!route?.includes("portal")) {
                            navigate("portal");
                          }
                        }}
                        className={
                          "childrens-parag mt-1" +
                          (darkMode ? " dark-mode" : "")
                        }
                      >
                        <img
                          src={
                            mainAddedChildren.length > 0 &&
                            mainPersonalInfo?.parent === null
                              ? item?.avatar
                              : mainPersonalInfo?.parent?.avatar
                          }
                          className="profile-pic-style me-2"
                          alt=""
                          style={{ width: "40px", height: "40px" }}
                        />
                        {mainAddedChildren.length > 0 &&
                        mainPersonalInfo?.parent === null
                          ? item?.fullName
                          : mainPersonalInfo?.parent?.fullName}
                      </div>
                    );
                  })}
                {mainPersonalInfo?.parent !== null && (
                  <div
                    style={{ cursor: "pointer" }}
                    className={
                      "childrens-parag mt-1" + (darkMode ? " dark-mode" : "")
                    }
                  >
                    <img
                      src={mainPersonalInfo?.parent?.avatar}
                      className="profile-pic-style me-2"
                      alt=""
                      style={{ width: "40px", height: "40px" }}
                    />
                    {mainPersonalInfo?.parent?.fullName}
                  </div>
                )}
              </>
            )
          )}
          {mainPersonalInfo?.parent === null &&
            mainPersonalInfo?.isUnderage === false && (
              <div className="add-children mt-3">
                <span
                  onClick={() => {
                    setAddChildren(true);
                    //*removed the searching step of adding children, instead moving directly to manual adding step
                    setTemp(true);
                    // if (mainFindChildren) {
                    //   dispatch(mainActions.getFindChildren());
                    // }
                  }}
                >
                  <PlusCircleBlueIcon style={{ marginTop: "-5px" }} />{" "}
                  <span>{f("myProfile.addChild")}</span>
                </span>
              </div>
            )}
          <hr />
          <div
            className={"parags" + (darkMode ? " dark-mode" : "")}
            onClick={() => {
              navigate("account");
              dispatch(mainActions.setOpenUserModal(false));
            }}
          >
            {f("myProfile.checkProfile")}
          </div>{" "}
          <hr />
          <div
            className={"parags" + (darkMode ? " dark-mode" : "")}
            onClick={() => setIsChangePassword(true)}
          >
            {f("myProfile.changePassword")}
          </div>
          <div>
            <button
              className="btn btn-danger log-out-button mx-auto mt-5"
              onClick={() => {
                dispatch(authActions.logoutUser());
                dispatch(actions.setApplicationDarkMode(false));
              }}
            >
              {f("myProfile.exit")}
            </button>
          </div>
        </>
      )}
      {temp && !isChangePassword && (
        <>
          <div className="text-center">
            <span
              className={"add-children-header" + (darkMode ? " dark-mode" : "")}
            >
              {f("myProfile.addChild")}
            </span>{" "}
            <XClose
              onClick={() => {
                setAddedSuccesfully(false);
                setAddChildren(false);
                setTemp(false);
                dispatch(mainActions.setAddchild(false));
              }}
              style={{ float: "right", cursor: "pointer" }}
            />
          </div>
          <div className="form-floating pb-1 mt-3">
            <input
              type="text"
              className={"form-control"}
              id="floatingInput"
              value={pId}
              placeholder="Input"
              onChange={(e) => setPId(e.target.value)}
              autoComplete="off"
              autoFocus
            />
            <label htmlFor="floatingInput">{f("myProfile.persNumber")}</label>
          </div>
          <div className="mt-3 main-profile-date-picker">
            <CustomDatePicker
              {...{
                date: birthDate,
                setDate: setBirthDate,
                title: f("myProfile.birthDate"),
              }}
            />
          </div>
          {mainCheckChild === null ? (
            <>
              <div className="text-warning-underage mt-2 mb-3 text-danger">
                {f("myProfile.childAgeWarningText")}
              </div>
            </>
          ) : (
            ""
          )}
          <div className="row mt-2">
            <div className="col-1 text-danger">*</div>
            <div
              className={"col-11 info-parag" + (darkMode ? " dark-mode" : "")}
            >
              {f("myProfile.ageLaw")}
            </div>
            <div className="col-1 text-danger mt-2">*</div>
            <div
              className={
                "col-11 info-parag mt-2" + (darkMode ? " dark-mode" : "")
              }
            >
              {f("myProfile.smsForInsurer")}
            </div>
          </div>
          <div>
            <button
              onClick={() => {
                dispatch(
                  mainActions.getCheckChild({
                    personalNumber: pId,
                    birthdate: formatedBirthDate,
                  })
                );
              }}
              disabled={pId === "" || birthDate === null}
              className="btn btn-primary next-button mx-auto mt-3"
            >
              {f("myProfile.next")}
            </button>
          </div>
        </>
      )}

      {addChildren && !isChangePassword && !temp && (
        <>
          <div className="text-center mb-3">
            <span
              className={"add-children-header" + (darkMode ? " dark-mode" : "")}
            >
              {f("myProfile.addChild")}
            </span>{" "}
            <XClose
              onClick={() => {
                setAddedSuccesfully(false);
                setAddChildren(false);
                setChildChoosed(false);
                setTemp(false);
                dispatch(mainActions.setAddchild(false));
                dispatch(mainActions.setCheckChild(false));
              }}
              style={{ float: "right", cursor: "pointer" }}
            />
          </div>
          {/* //* removed unnessesarry step of choosing to add child manually and the automatic adding*/}
          {/* {!childChoosed && !addedSuccesfully && (
            <>
              {mainFindChildren === null ? (
                <span
                  className="spinner-border spinner-border-sm d-flex mx-auto"
                  role="status"
                  aria-hidden="true"
                ></span>
              ) : (
                mainFindChildren?.map((item) => {
                  return (
                    <div
                      style={{ cursor: "pointer" }}
                      className="childs-insured ps-3 mb-3"
                      onClick={() => {
                        childAdd != item?.personalNumber
                          ? setChildAdd(item?.personalNumber)
                          : setChildAdd(false);
                      }}
                    >
                      <span className="me-2">
                        {item?.firstName} {item?.lastName}
                      </span>
                      <span className="insuranceCompany">
                        {item?.organizationName}
                      </span>
                      {childAdd === item?.personalNumber && (
                        <CheckBlueIcon
                          className="blueIcon"
                          style={{ marginTop: "16px" }}
                        />
                      )}
                    </div>
                  );
                })
              )}
              <div
                className="addManually mt-3 mb-4"
                onClick={() => {
                  setTemp(true);
                }}
              >
                <PlusCircleBlueIcon className="me-2" />
                <span>{f("myProfile.addManually")}</span>
              </div>
              <div className="listInfo row">
                <ul>
                  <li className="mb-2 d-flex">
                    <span className="asterisk me-2">*</span>
                    <div className="col-12">{f("myProfile.ageLaw")}</div>
                  </li>
                  <li className="mb-2 d-flex">
                    <span className="asterisk me-2">*</span>
                    <div className="col-12">{f("myProfile.smsForInsurer")}</div>
                  </li>
                </ul>
              </div>
              <div>
                <button
                  className="btn btn-primary next-button mx-auto mt-3"
                  onClick={() => {
                    setChildChoosed(true);
                    dispatch(mainActions.getSendOTPInsurer());
                  }}
                  disabled={!childAdd}
                >
                  {f("myProfile.next")}
                </button>
              </div>
            </>
          )} */}
          {childChoosed && (
            <>
              <div className="sms-parag mb-5">
                {f("myProfile.pleaseEnter1")} {insurerMobile}{" "}
                {f("myProfile.pleaseEnter2")}
              </div>
              <div className="form-floating mb-4">
                <input
                  type="text"
                  className={"form-control"}
                  id="floatingInput"
                  value={smsCode}
                  placeholder="Input"
                  onChange={(e) => setSmscode(e.target.value)}
                  autoComplete="off"
                  autoFocus
                />
                <label htmlFor="floatingInput">{f("myProfile.smsCode")}</label>
              </div>
              <div>
                <div className="timer text-brand-pink timer-tick text-center">
                  {formatTimer(pinTimer)}
                </div>
                {loading === true ? (
                  <span
                    className="spinner-border spinner-border-sm d-flex mx-auto"
                    role="status"
                    aria-hidden="true"
                  ></span>
                ) : (
                  <button
                    className="btn btn-primary next-button mx-auto mt-3"
                    onClick={() => {
                      setLoading(true)?.then(() => {
                        setLoading(false);
                      });
                      if (mainAddChild) {
                        setAddedSuccesfully(true);
                        setTemp(false);
                      } else {
                        setLoading(false);
                      }
                      dispatch(
                        mainActions.getAddchild({
                          birthDate: formatedBirthDate,
                          personalNumber: pId,
                          otp: smsCode,
                        })
                      );
                    }}
                  >
                    {f("myProfile.next")}
                  </button>
                )}
                <div
                  className="sms-parag mt-2"
                  style={{
                    cursor: pinTimer <= 0 ? "pointer" : "unset",
                    opacity: pinTimer <= 0 ? "1" : "0.5",
                  }}
                  onClick={() => {
                    if (pinTimer <= 0) {
                      dispatch(
                        mainActions.getSendOTPInsurer({ personalNumber: pId })
                      );
                    }
                  }}
                >
                  {f("myProfile.againCode")}
                </div>
              </div>
            </>
          )}
        </>
      )}
      {mainAddChild && addedSuccesfully && (
        <>
          <div>
            <div className="text-center mt-4 mb-4">
              <CheckGreenIcon />
            </div>
            <div className="child-added">{f("myProfile.addedSuccess")}</div>
            <div className="check-profile mt-4 mb-5">
              {f("myProfile.pleaseCheckProfile")}
            </div>
          </div>
          <div>
            <button
              className="btn btn-primary next-button mx-auto mt-3"
              onClick={() => {
                navigate("account");
                setAddedSuccesfully(false);
                setAddChildren(false);
                setChildChoosed(false);
                setTemp(false);
                dispatch(mainActions.setAddchild(false));
                dispatch(mainActions.setCheckChild(false));
                dispatch(mainActions.setOpenUserModal(false));
              }}
            >
              {f("myProfile.next")}
            </button>
          </div>
        </>
      )}

      {isChangePassword && (
        <>
          <div className="text-center">
            <span
              className={"add-children-header" + (darkMode ? " dark-mode" : "")}
            >
              {f("myProfile.changePassword")}{" "}
            </span>{" "}
            <XClose
              onClick={() => {
                setAddedSuccesfully(false);
                setIsChangePassword(false);
                setTemp(false);
                dispatch(mainActions.setAddchild(false));
                dispatch(mainActions.setCheckChild(false));
                dispatch(mainActions.setChangePassword(false));
                setNewPassword("");
                setRepeateNewPassword("");
                setOldPassword("");
              }}
              style={{ float: "right", cursor: "pointer" }}
            />
          </div>
          <div>
            <div className="form-floating pb-1 mt-3">
              <input
                type={oldPasswordVisible ? "text" : "password"}
                className={"form-control loginInput"}
                id="floatingPassword"
                value={oldPassword}
                placeholder="Password"
                onChange={(e) => setOldPassword(e.target.value)}
                autoComplete="off"
                autoFocus
              />
              <label htmlFor="floatingPassword" style={{ color: "#424244" }}>
                {f("myProfile.oldPassword")}
              </label>
            </div>
            {oldPasswordVisible === true ? (
              <EyeOn
                className="toggle-eye-style"
                onClick={() => setOldPasswordVisible(!oldPasswordVisible)}
              />
            ) : (
              <EyeOff
                className="toggle-eye-style"
                onClick={() => setOldPasswordVisible(!oldPasswordVisible)}
              />
            )}
          </div>
          <div>
            <div className="form-floating pb-1 mt-3">
              <input
                type={newPasswordVisible ? "text" : "password"}
                className={"form-control loginInput"}
                id="floatingPassword"
                value={newPassword}
                placeholder="Password"
                onChange={(e) => setNewPassword(e.target.value)}
                autoComplete="off"
              />
              <label htmlFor="floatingPassword" style={{ color: "#424244" }}>
                {f("myProfile.newPassword")}
              </label>
            </div>
            {newPasswordVisible === true ? (
              <EyeOn
                className="toggle-eye-style"
                onClick={() => setNewPasswordVisible(!newPasswordVisible)}
              />
            ) : (
              <EyeOff
                className="toggle-eye-style"
                onClick={() => setNewPasswordVisible(!newPasswordVisible)}
              />
            )}
          </div>
          <div>
            <div className="form-floating pb-1 mt-3">
              <input
                type={repeatPasswordVisible ? "text" : "password"}
                className={"form-control loginInput"}
                id="floatingPassword"
                value={repeateNewPassword}
                placeholder="Password"
                onChange={(e) => setRepeateNewPassword(e.target.value)}
                autoComplete="off"
              />
              <label htmlFor="floatingPassword" style={{ color: "#424244" }}>
                {f("myProfile.repeatPassword")}
              </label>
            </div>
            {repeatPasswordVisible === true ? (
              <EyeOn
                className="toggle-eye-style"
                onClick={() => setRepeatPasswordVisible(!repeatPasswordVisible)}
              />
            ) : (
              <EyeOff
                className="toggle-eye-style"
                onClick={() => setRepeatPasswordVisible(!repeatPasswordVisible)}
              />
            )}
          </div>
          {Array?.isArray(changePassword?.exceptionCode) && (
            <StrongPasswordValidation
              exceptionCode={changePassword?.exceptionCode}
              f={f}
            />
          )}
          {anyPasswordHasSpace && (
            <span className="error-text-style">{f("passwrod-has-space")}</span>
          )}
          {message && <span className="error-text-style">{message}</span>}
          <div>
            <button
              onClick={() => {
                dispatch(
                  mainActions.getChangePassword({
                    oldPassword: oldPassword,
                    newPassword: newPassword,
                    confirmNewPassword: repeateNewPassword,
                  })
                );
              }}
              disabled={
                oldPassword === "" ||
                newPassword === "" ||
                repeateNewPassword === "" ||
                anyPasswordHasSpace
              }
              className="btn btn-primary next-button mx-auto mt-3"
            >
              {f("myProfile.save")}
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default MyProfileContainer;
